import { render } from "./EditSystemUser.vue?vue&type=template&id=b61a8288"
import script from "./EditSystemUser.vue?vue&type=script&lang=js"
export * from "./EditSystemUser.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/hrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__